export enum AppSpace {
  CUSTOMERCARD = 'CustomerCard',
  SCHEDULE = 'Schedule',
  DIRECTORY = 'Directory',
  SENTIMENT = 'Sentiment',
  ENLIGHTEN = 'Enlighten',
  APP_HEALTH = 'AppHealth',
  QUICK_REPLY = 'QuickReply',
  CONVERSATIONS = 'Conversations',
  COPILOT = 'Copilot',
  QUEUE ='Queue',
  CONTACT_HISTORY = 'Contact History',
}

